<template>
  <div id="dashboard" class="content">
    <div class="row">
      <div class="col-12">
        <a class="block block-rounded" href="javascript:void(0)">
          <div class="block-header block-header-default">
            <h3 class="block-title">总用电量(度)</h3>
          </div>
          <div class="block-content block-content-full">
            <div class="row text-center">
              <div class="col-12"></div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                  >{{(stats && stats.yesterdayDegree+'') || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.startDate}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p class="font-size-125 font-w300 mb-0">{{(stats && stats.sumDegree+'') || '--'}}</p>
                  <p class="text-muted mb-0 font-size-75">{{duration.label}}</p>
                </div>
              </div>
              <div class="col-4">
                <div class="py-0">
                  <p
                    class="font-size-125 font-w300 mb-0"
                    v-html="(stats && compare(stats.seqDegree)+'')  || '--'"
                  ></p>
                  <p class="text-muted mb-0 font-size-75">环比</p>
                </div>
              </div>
            </div>
            <div class="row">
              <div id="chart-seq-degree" style="width: 100%; height: 200px"></div>
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="col-12" style="margin-bottom: 10px;">
      <div class="row mb-2 mt-4" style="margin-right: -64px;">
        <div class="col-6 row">
          <h2 class="h3 font-w400 mb-0 line-height">每日用电量</h2>
        </div>
        <div class="col-6 text-right mr-0">
          <screenTime :isToday="'1'" @changePage="changePage"></screenTime>
        </div>
      </div>
    </div>
    <div class="block block-rounded block-bordered">
      <div class="block-header block-header-default">
        <h3 class="block-title">{{ '时间范围： ' + duration.startDate + ' 至 ' + this.duration.endDate }}</h3>
        <div class="block-options">
          <button
            type="button"
            class="btn-block-option"
            data-toggle="block-option"
            data-action="fullscreen_toggle"
          >
            <i class="si si-size-fullscreen"></i>
          </button>
        </div>
      </div>
      <div class="block-content block-content-full">
        <div class="dataTables_wrapper dt-bootstrap4 no-footer">
          <div class="row mb-1">
            <div class="col-12 col-md-4 text-center text-md-left">
              <pageSize @changePageSize="changePageSize"></pageSize>
            </div>
            <div class="col-12 col-md-4 text-center text-md-center" v-show="!isMobile">
              <div class="dt-buttons">
                <button
                  class="dt-button buttons-copy buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  tabindex="0"
                  aria-controls="DataTables_Table_1"
                  data-clipboard-text
                  @click="copy()"
                  type="button"
                  id="copybtn"
                >
                  <span>复制</span>
                </button>
                <button
                  class="dt-button buttons-csv buttons-html5 btn btn-sm btn-primary mr-2 pding-btn"
                  @click="exportCSV()"
                  type="button"
                >
                  <span>导出</span>
                </button>
                <button
                  class="dt-button buttons-print btn btn-sm btn-primary mr-2 pding-btn"
                  @click="print()"
                >
                  <span>打印</span>
                </button>
              </div>
            </div>
            <div class="col-12 col-md-4 text-center text-md-right">
              <div class="dataTables_filter">
                <label>
                  <input
                    type="search"
                    class="form-control"
                    placeholder="搜索"
                    v-model="key"
                    @keyup.enter="search()"
                  />
                </label>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <div class="table-responsive">
                <section ref="print">
                  <table
                    class="table table-bordered table-striped table-vcenter js-dataTable-full dataTable no-footer"
                  >
                    <thead>
                      <tr>
                        <th
                          class="text-center sorting"
                          style="width: 60px; min-width:60px"
                          @click="getList('ID',$event)"
                        >#</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('DATE_TIME',$event)"
                        >日期</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('CARPORT_NAME',$event)"
                        >车棚名称</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('CELL_NAME',$event)"
                        >小区名称</th>
                        <!-- <th
                          class="text-left sorting"
                          style="width:150px;min-width:150px;"
                          @click="getList('PROPERTY_NAME',$event)"
                        >所属物业</th>-->
                        <!-- <th
                          class="text-left sorting"
                          style="width:150px;min-width:150px;"
                          @click="getList('AGENT_NAME',$event)"
                        >所属代理商</th>-->
                        <th
                          class="text-left sorting"
                          style="width:100px;min-width:100px;"
                          @click="getList('METER_NUM',$event)"
                        >电表数量</th>
                        <th
                          class="text-left sorting"
                          style="width:110px;min-width:110px;"
                          @click="getList('PILE_NUM',$event)"
                        >充电桩数量</th>
                        <th
                          class="text-left sorting"
                          style="width:100px;min-width:100px;"
                          @click="getList('PORT_NUM',$event)"
                        >端口数量</th>
                        <th
                          class="text-left sorting"
                          style="width:125px;min-width:125px;"
                          @click="getList('ENTRANCE_NUM',$event)"
                        >智能门闸数量</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('UNIFIED_CONSUME_POWER',$event)"
                        >总用电量(度)</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('ELECTRICITY_RATE',$event)"
                        >结算电价(元)</th>
                        <th
                          class="text-left sorting"
                          style="width:120px;min-width:120px;"
                          @click="getList('ELECTRICTY_MONEY',$event)"
                        >用电成本(元)</th>
                      </tr>
                    </thead>
                    <tbody v-if="degreeList.length">
                      <tr v-for="(item, i) in degreeList" :key="i">
                        <td class="text-center">{{ i + 1 }}</td>
                        <td class="text-left font-w600">{{ item.DATE_TIME }}</td>
                        <td class="text-left d-md-table-cell">{{ item.CARPORT_NAME }}</td>
                        <td class="text-left d-md-table-cell">{{ item.CELL_NAME }}</td>
                        <!-- <td class="text-left d-md-table-cell">{{ item.PROPERTY_NAME }}</td>
                        <td class="text-left d-md-table-cell">{{ item.AGENT_NAME }}</td>-->
                        <td class="text-left" style="width:150px">{{ item.METER_NUM }}</td>
                        <td class="text-left" style="width:150px">{{ item.PILE_NUM }}</td>
                        <td class="text-left" style="width:150px">{{ item.PORT_NUM }}</td>
                        <td class="text-left" style="width:150px">{{ item.ENTRANCE_NUM }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.UNIFIED_CONSUME_POWER) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.ELECTRICITY_RATE) }}</td>
                        <td
                          class="text-left"
                          style="width:150px"
                        >{{ changeTwoDecimal(item.ELECTRICTY_MONEY) }}</td>
                      </tr>
                    </tbody>
                    <tbody v-else>
                      <tr>
                        <td class="text-center" colspan="11">查无数据</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-5 text-center text-md-left" v-show="!isMobile">
              <div class="dataTables_info" role="status" aria-live="polite">
                页数
                <strong>{{ page }}</strong> /
                <strong>{{ totalPage }}</strong>
              </div>
            </div>
            <div class="col-sm-12 col-md-7 text-center text-md-right">
              <div class="dataTables_paginate paging_full_numbers">
                <el-pagination
                  v-if="degreeList && degreeList.length"
                  @current-change="handleCurrentChange"
                  :current-page="page"
                  :page-size="pageSize"
                  :pager-count="pagerCount"
                  :layout="isMobile ? 'prev, pager, next':'total, prev, pager, next'"
                  :small="isMobile"
                  :total="total"
                  background
                ></el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// 引入基本模板
let echarts = require("echarts/lib/echarts");
// 引入柱状图组件
require("echarts/lib/chart/pie");
require("echarts/lib/chart/bar");
require("echarts/lib/chart/line");
require("echarts/lib/chart/map");
import Util from "../../../Util.js";
import screenTime from "../../../components/screenTime";
import pageSize from "../../../components/pageSize";

export default {
  name: "index",
  data() {
    return {
      degreeList: [],
      entry: {},
      setToday: new Date(),
      starttime: "",
      endtime: "",
      key: "",
      page: 1,
      size: 10,
      total: 1,
      pageSize: 20,
      selects: [10, 20, 30, 50],
      clipboard: null,
      sorting: "",
      orderBy: false,
      totalList: [],
      agents: [],
      stats: null,
      charts: [],
      entryUrl: "",
      url: ""
    };
  },
  components: {
    screenTime,
    pageSize
  },
  computed: {
    duration() {
      return this.$store.state.duration;
    },
    roleName() {
      return this.$store.state.roleName;
    },
    totalPage() {
      if (this.total == 0) {
        return 0;
      } else {
        return Math.ceil(this.total / this.pageSize, 1);
      }
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    pagerCount() {
      return this.$store.state.pagerCount;
    },
    userInfo() {
      return this.$store.state.userInfo;
    },
    params() {
      return this.$store.state.params;
    },
    regionParams() {
      return this.$store.state.regionParams;
    }
  },
  watch: {
    "$store.state.duration": {
      handler: function(val, oldVal) {
        if (typeof oldVal === "undefined") return;
        if (JSON.stringify(val) != JSON.stringify(oldVal)) {
          this.getList();
          this.getEchart();
        }
      },
      immediate: true,
      deep: true
    },

    key(val, oldVal) {
      if (val.length == 0) {
        this.getList();
      }
    }
  },
  mounted() {
    if (this.$route.params.type) {
      this.$store.commit("setParam", {
        params: this.$route.params
      });
    }
    // 折线图
    Util.getUrl(this, "CarportStat/Query", "CarportStat/ListByUseDegree");
    let that = this;
    window.onresize = function() {
      setTimeout(_ => {
        that.resizeCharts();
      }, 500);
    };
    // this.getEntry()
    this.getList();
    this.copy();
    this.getEchart();
  },
  methods: {
    changePageSize(val) {
      this.pageSize = val;
      this.page = 1;
    },
    changePage(val) {
      this.page = val;
    },
    changeTwoDecimal(val) {
      return Util.changeTwoDecimal(val);
    },
    compare: val => {
      let modifier = val > 0 ? "+ " : "";
      let color = val > 0 ? "green" : "red;";
      return `<div style="color: ${color}">${modifier}${val}${
        val == "-" ? "" : "%"
      }</div>`;
    },
    resizeCharts() {
      for (let i = 0; i < this.charts.length; i++) {
        const chart = this.charts[i];
        chart.resize();
      }
    },
    selectVal(ele) {
      this.selected = ele.target.value;
    },
    getEchart() {
      this.$http
        .get(
          `${this.entryUrl}${this.duration.startDate}/${this.duration.endDate}?region=${this.regionParams.region}&object=${this.regionParams.object}`
        )
        .then(result => {
          if (result.data.data) {
            this.stats = result.data.data;
            $(function() {
              Dashmix.helpers([
                "easy-pie-chart",
                "sparkline",
                "datepicker",
                "flatpickr"
              ]);
            });
            $(".js-dataTable-buttons").DataTable();
            $(".js-dataTable-buttons")
              .DataTable()
              .clear();
            const dates = _.map(this.stats.log, x => x.statistics_date);
            setTimeout(() => {
              Util.initChart(
                this,
                "chart-seq-degree",
                dates,
                _.map(this.stats.log, x => x.chargePower),
                "#83b451",
                "line",
                "度"
              );
            }, 500);
          }
        });
    },
    getList(sorting, that) {
      let params = {};
      if (this.key.length > 0) {
        params["key"] = this.key.trim();
      }

      if (sorting != undefined || this.sorting.length > 0) {
        this.sorting = sorting == undefined ? this.sorting : sorting;
        params["sort"] = this.sorting;
        params["orderBy"] = this.orderBy;

        if (that != undefined && that.currentTarget != undefined) {
          var obj = that.currentTarget;
          if (
            $(obj).is(".sorting_asc") ||
            $(obj).is(".sorting_desc") ||
            $(obj).is(".sorting")
          ) {
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_asc");
            $(obj)
              .parent("tr")
              .children("th")
              .removeClass("sorting_desc");
            $(obj).addClass(this.orderBy ? "sorting_asc" : "sorting_desc");
            this.orderBy = !this.orderBy;
            params["orderBy"] = this.orderBy;
          }
        }
      }
      this.$http
        .get(
          `${this.url}${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params
          }
        )
        .then(res => {
          if (res.data.code === 200) {
            this.degreeList = res.data.data.data;
            this.total = res.data.data.pageInfo.total;
          }
        });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getList();
    },
    search() {
      this.page = 1;
      this.getList();
    },
    exportCSV() {
      let params = {};
      if (this.key) {
        params["key"] = this.key.trim();
      }
      // params['key'] =  ''
      params["down"] = 1;
      params["sort"] = this.sorting;
      params["orderBy"] = this.orderBy;
      this.$http
        .get(
          `${this.url}${this.duration.startDate}/${this.duration.endDate}/${this.page}/${this.pageSize}?region=${this.regionParams.region}&object=${this.regionParams.object}`,
          {
            params: params,
            responseType: "blob"
          }
        )
        .then(res => {
          if (res.status === 200) {
            Util.ExportCSV(res);
          }
        });
    },
    print() {
      this.$print(this.$refs.print);
    },
    copy() {
      let copyStr = document.getElementsByTagName("section")[0].innerText;
      var btn = document.getElementById("copybtn");
      btn.setAttribute("data-clipboard-text", copyStr);
      var clipboard = new ClipboardJS(btn);
      this.clipboard = new ClipboardJS(btn);
      this.clipboard.on("success", e => {
        Util.message("succ", "复制成功");
        this.clipboard.destroy();

        e.clearSelection();
      });
    }
  }
};
</script>
<style scoped lang="less">
.badge {
  font-weight: 400 !important;
}
.custom-control-inline {
  margin-right: 3rem;
}
.custom-control {
  label {
    font-size: 0.9375rem;
    font-weight: 400;
  }
}
</style>